import { useMapViewerContext } from '../../../Context/MapViewerContext';

const ZOOM_LIMIT = 0.33;
const DEFAULT_FONT_SIZE = 14;
const EXPORT_MAP_COTE_FONT_SIZE = 10;

export const MapZoomContants = { ZOOM_LIMIT, DEFAULT_FONT_SIZE, EXPORT_MAP_COTE_FONT_SIZE };

export const useMapZoomScale = () => {
    const mapZoom = useMapViewerContext().value?.a ?? 1;
    const scale = mapZoom > 1 ? 1 : 1 / mapZoom;
    return scale === Infinity ? 1 : scale; // fix console error when map is initializing
};

export function toCoteSizeText(defaultSize: number, mapZoom: number = 1): number {
    let fontSize = 14;
    let keepSize = 14;
    const textSize = fontSize * mapZoom;
    if (textSize > defaultSize) {
        fontSize = defaultSize;
        console.log('useMapViewerContext max', { fontSize, mapZoom, textSize, defaultSize });
    } else if (textSize < keepSize && textSize > 5) {
        fontSize = keepSize;
        console.log('useMapViewerContext keep size', { fontSize, mapZoom, textSize, defaultSize });
    } else {
        fontSize = textSize;
        console.log('useMapViewerContext return', { fontSize, mapZoom, textSize, defaultSize });
    }

    return fontSize;
}

export function useScaleCoteSizeText(defaultSize: number = DEFAULT_FONT_SIZE): number {
    const mapZoom = useMapViewerContext().value.a;
    const scale = (mapZoom > 1 || mapZoom < ZOOM_LIMIT) ? 1 : 1 / mapZoom;
    const size = scale * defaultSize;
    return size;
}

export const useTextSizeRectWidth = (sizeTextLength: number) => {
    const mapZoom = useMapViewerContext().value.a;
    const scale = (mapZoom > 1 || mapZoom < ZOOM_LIMIT) ? 1 : 1 / mapZoom;
    const textSizeRectWidth = sizeTextLength * scale;
    return textSizeRectWidth;
};

export const useMapZoomScaleWithLimit = (shrinkScale: number = 1) => {
    const mapZoom = useMapViewerContext().value?.a ?? 1;
    const scale = (mapZoom > 1 || mapZoom < ZOOM_LIMIT) ? 1 : 1 / mapZoom;
    return scale / shrinkScale;
};